import React from 'react';

const filterOptions = [
  { key: 'applied_new', label: 'Applied (New)' },
  { key: 'attended', label: 'Attended Meet & Greet' },
  { key: 'rejected', label: 'Rejected' },
  { key: 'left', label: 'Left' },
  { key: 'registered_startupworld', label: 'Registered at StartupWorld' },
  { key: 'assigned', label: 'Assigned with Projects' }
];


const getStatusText = (app) => {
  if (app.rejected) return 'Rejected';
  if (app.left) return 'Left';
  if (app.assigned_project) return 'Assigned';
  if (app.attended_meet_greet) return 'Attended';
  if (app.registered_startupworld) return 'Registered at StartupWorld';
  if (app.registered) return 'Registered';
  return 'Pending';
};



const FiltersSection = ({ selectedFilter, handleFilterChange, filteredData, filterPage, setFilterPage }) => {
  const totalPages = filteredData.pagination?.totalPages || 1;
  const total = filteredData.pagination?.total || 0;
  // Use backend's current page if available, else local state
  const currentPage = filteredData.pagination?.page || filterPage || 1;

  // When filter changes, reset to page 1
  React.useEffect(() => {
    setFilterPage(1);
  }, [selectedFilter, setFilterPage]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && newPage !== currentPage) {
      setFilterPage(newPage);
      handleFilterChange(selectedFilter, newPage);
    }
  };

  return (
    <div className="filters-section">
      <div className="filter-controls">
        <h3>Filter Applicants</h3>
        <div className="filter-buttons">
          {filterOptions.map(opt => (
            <button
              key={opt.key}
              className={`filter-btn${selectedFilter === opt.key ? ' active' : ''}`}
              onClick={() => { setFilterPage(1); handleFilterChange(opt.key, 1); }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
      <div className="filtered-results">
        <div className="results-header">
          <h4>Results</h4>
          <span className="results-summary">
            {total} applicants found
          </span>
        </div>
        <div className="applicants-table">
          <table>
            <thead>
              <tr>
                <th>ATS Number</th>
                <th>Name</th>
                <th>Email</th>
                <th>Domain</th>
                <th>Source</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {(filteredData.data || []).map(app => (
                <tr key={app.ats_number} className="applicant-row">
                  <td className="ats-number">{app.ats_number}</td>
                  <td className="applicant-name"><strong>{app.first_name} {app.last_name}</strong></td>
                  <td className="email">{app.email_id}</td>
                  <td className="domain">{app.domain}</td>
                  <td className="source">{app.source}</td>
                  <td className="date">{app.application_date}</td>
                  <td>
                    <span className={`status-badge ${getStatusText(app).toLowerCase().replace(/ /g, '-')}`}>{getStatusText(app)}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="pagination-controls" style={{ marginTop: 20, display: 'flex', justifyContent: 'center', gap: 8, flexWrap: 'wrap' }}>
            {/* Modern styled nav buttons */}
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              style={{
                background: currentPage === 1 ? '#f3f4f6' : '#e0e7ff',
                border: '1px solid #d1d5db',
                color: currentPage === 1 ? '#9ca3af' : '#1d4ed8',
                fontWeight: 'bold',
                fontSize: 15,
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                padding: '4px 14px',
                borderRadius: 4,
                marginRight: 2,
                marginLeft: 2
              }}
            >
              First
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                background: currentPage === 1 ? '#f3f4f6' : '#e0e7ff',
                border: '1px solid #d1d5db',
                color: currentPage === 1 ? '#9ca3af' : '#1d4ed8',
                fontWeight: 'bold',
                fontSize: 15,
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                padding: '4px 14px',
                borderRadius: 4,
                marginRight: 2,
                marginLeft: 2
              }}
            >
              Prev
            </button>
            {/* Page number buttons */}
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNum => {
              if (
                pageNum === 1 ||
                pageNum === totalPages ||
                (pageNum >= currentPage - 2 && pageNum <= currentPage + 2)
              ) {
                return (
                  <button
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    style={{
                      fontWeight: currentPage === pageNum ? 'bold' : 'normal',
                      background: currentPage === pageNum ? '#3b82f6' : 'white',
                      color: currentPage === pageNum ? 'white' : '#1f2937',
                      border: '1px solid #d1d5db',
                      borderRadius: 4,
                      minWidth: 32,
                      margin: '0 2px',
                      cursor: currentPage === pageNum ? 'default' : 'pointer',
                      transition: 'background 0.2s',
                    }}
                    disabled={currentPage === pageNum}
                  >
                    {pageNum}
                  </button>
                );
              } else if (
                (pageNum === currentPage - 3 && currentPage - 3 > 1) ||
                (pageNum === currentPage + 3 && currentPage + 3 < totalPages)
              ) {
                return <span key={pageNum} style={{ padding: '0 6px' }}>...</span>;
              }
              return null;
            })}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{
                background: currentPage === totalPages ? '#f3f4f6' : '#e0e7ff',
                border: '1px solid #d1d5db',
                color: currentPage === totalPages ? '#9ca3af' : '#1d4ed8',
                fontWeight: 'bold',
                fontSize: 15,
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                padding: '4px 14px',
                borderRadius: 4,
                marginRight: 2,
                marginLeft: 2
              }}
            >
              Next
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              style={{
                background: currentPage === totalPages ? '#f3f4f6' : '#e0e7ff',
                border: '1px solid #d1d5db',
                color: currentPage === totalPages ? '#9ca3af' : '#1d4ed8',
                fontWeight: 'bold',
                fontSize: 15,
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                padding: '4px 14px',
                borderRadius: 4,
                marginRight: 2,
                marginLeft: 2
              }}
            >
              Last
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FiltersSection;